<template>
    <div>
        <!-- 现舱市场 -->
        <!-- 背景动画效果 -->
        <div class="mappp"   ref="mapContainer">
          <!-- <transition name="地面">
            <div v-if="isDiMianVisible" class="map_xiao map_xiao_111"></div>
          </transition>
          <div class="line-container">
            <transition name="船">
              <div class="map_xiao map_xiao_1" v-if="isChuanVisible"></div>
            </transition> -->
            <!-- <transition name="集装箱">
              <div  v-if="isJiZhuangXiangVisible"  class="point map_xiao map_xiao_2"></div>
            </transition> -->
            <!-- <transition name="房子">
              <div  v-if="isFangZiVisible"  class="point map_xiao map_xiao_3"></div>
            </transition>
            <transition name="吊机">
              <div  v-if="isDiaoJiVisible"  class="point map_xiao map_xiao_4"></div>
            </transition>
          </div> -->

          <!--  -->
          <div class="xiancsj typeArea">
            <div class="xcsj_bt">
              <Animation :message="xc_parentMessage" />
                <!-- <div>
                    <p  class="xc_left">现舱市场</p>
                    <p>供应商发布海量现舱资源等你来</p>
                </div> -->
                <div class="xc_right">
                    <el-button type="primary" round @click="chakangengduo">
                        查询更多
                        <img src="../../assets/Frame(2).png" />
                    </el-button>
                </div>
            </div>
           <div v-if="xcscList.length>8">
            <vue-seamless-scroll :data="xcscList" class="warp" :class-option="classOption">
              <div class="xc_concent">
                <div
                v-for="(item,index) in xcscList" :key="index"
                 class="xc_son">
                    <div @click="tiaozhuan(item)">
                      <div class="son_title">
                          <span>{{item.pol_name}}</span>
                          <img src="../../assets/Group 98(1).png" />
                          <span>{{item.pod_name}}</span>
                      </div>
                      <div class="son_num">
                        箱型数量：
                        <span
                        v-for="(it,ind) in item.basic_freight"
                        :key="ind"
                          >{{it.box_type}}*{{it.number}}
                          <span v-if="ind != item.basic_freight.length-1"> / </span>
                        </span>
                      </div>
                      <div class="son_num">
                        箱型价格：
                        <span
                        v-for="(it,ind) in item.basic_freight"
                        :key="ind"
                          >{{it.box_type}}：$ {{it.price}}
                          <span v-if="ind != item.basic_freight.length-1"> / </span>
                        </span>
                      </div>
                      <div class="son_con">
                          <div class="son_f"><span class="spanspan">ETD/ETA：</span>{{item.etd}}/{{item.eta}}</div>
                          <div><span  class="spanspan">中转/直达：</span>{{item.is_transit == 0 ?'直达':'中转'}}</div>
                          <div><span class="spanspan">运输条款：</span>{{item.transportation_terms}}</div>
                          <div><span class="spanspan">箱源：</span>{{item.box_source}}</div>
                          <div><span class="spanspan">供应商：</span>{{item.supplier_sn}}</div>
                          <div><span class="spanspan">联系电话：</span>{{item.mobile}}</div>
                      </div>
                    </div>
                    <div class="querem">
                      <el-button @click="faqi(item)">详情</el-button>
                    </div>
                </div>
              </div>
              <div class="xc_concent">
                <div
                v-for="(item,index) in xcscreverseList" :key="index"
                 class="xc_son">
                    <div @click="tiaozhuan(item)">
                      <div class="son_title">
                          <span>{{item.pol_name}}</span>
                          <img src="../../assets/Group 98(1).png" />
                          <span>{{item.pod_name}}</span>
                      </div>
                      <div class="son_num">
                        箱型数量：
                        <span
                        v-for="(it,ind) in item.basic_freight"
                        :key="ind"
                          >{{it.box_type}}*{{it.number}}
                          <span v-if="ind != item.basic_freight.length-1"> / </span>
                        </span>
                      </div>
                      <div class="son_num">
                        箱型价格：
                        <span
                        v-for="(it,ind) in item.basic_freight"
                        :key="ind"
                          >{{it.box_type}}：$ {{it.price}}
                          <span v-if="ind != item.basic_freight.length-1"> / </span>
                        </span>
                      </div>
                      <div class="son_con">
                          <div class="son_f"><span class="spanspan">ETD/ETA：</span>{{item.etd}}/{{item.eta}}</div>
                          <div><span  class="spanspan">中转/直达：</span>{{item.is_transit == 0 ?'直达':'中转'}}</div>
                          <div><span class="spanspan">运输条款：</span>{{item.transportation_terms}}</div>
                          <div><span class="spanspan">箱源：</span>{{item.box_source}}</div>
                          <div><span class="spanspan">供应商：</span>{{item.supplier_sn}}</div>
                          <div><span class="spanspan">联系电话：</span>{{item.mobile}}</div>
                      </div>
                    </div>
                    <div class="querem">
                      <el-button @click="faqi(item)">详情</el-button>
                    </div>
                </div>
              </div>
            </vue-seamless-scroll>
           </div>
           <div v-else>
              <div class="xc_concent xc_concenter">
                <div
                v-for="(item,index) in xcscList" :key="index"
                 class="xc_son"
                 >
                    <div @click="tiaozhuan(item)">
                      <div class="son_title">
                          <span>{{item.pol_name}}</span>
                          <img src="../../assets/Group 98(1).png" />
                          <span>{{item.pod_name}}</span>
                      </div>
                      <div class="son_num">
                        箱型数量：
                        <span
                        v-for="(it,ind) in item.basic_freight"
                        :key="ind"
                          >{{it.box_type}}*{{it.number}}
                          <span v-if="ind != item.basic_freight.length-1"> / </span>
                        </span>
                      </div>
                      <div class="son_num">
                        箱型价格：
                        <span
                        v-for="(it,ind) in item.basic_freight"
                        :key="ind"
                          >{{it.box_type}}：$ {{it.price}}
                          <span v-if="ind != item.basic_freight.length-1"> / </span>
                        </span>
                      </div>
                      <div class="son_con">
                          <div class="son_f"><span class="spanspan">ETD/ETA：</span>{{item.etd}}/{{item.eta}}</div>
                          <div><span  class="spanspan">中转/直达：</span>{{item.is_transit == 0 ?'直达':'中转'}}</div>
                          <div><span class="spanspan">运输条款：</span>{{item.transportation_terms}}</div>
                          <div><span class="spanspan">箱源：</span>{{item.box_source}}</div>
                          <div><span class="spanspan">供应商：</span>{{item.supplier_sn}}</div>
                          <div><span class="spanspan">联系电话：</span>{{item.mobile}}</div>
                      </div>
                    </div>
                    <div class="querem">
                      <el-button @click="faqi(item)">详情</el-button>
                    </div>
                </div>
              </div>
           </div>
        </div>
          <!-- 详情 -->
          <el-dialog width="45%" title="舱位详情" :visible.sync="dialogVisible" 
          @close-on-press-escape="quxiao"
          @close-on-click-modal="quxiao"
          @close="quxiao">
            <div class="dialogForm">
              <div class="shang">
                <div class="logo">
                  <img :src="dialogForm.shipping_companyLogo" alt="" />
                </div>
                <div class="qiyun">
                  <div class="date"><span class="jiacu">ETD:</span>{{ dialogForm.etd }}</div>
                  <div class="address">{{ dialogForm.pol_name }}</div>
                </div>
                <div class="dao">
                  <div class="tian">{{ dialogForm.shipping_date }}天</div>
                  <img src="@/assets/images/Group 113@2x.png" alt="" />
                  <div class="zhida">
                    {{ dialogForm.is_transit == 1 ? "中转" : "直达" }}
                  </div>
                </div>
                <div class="qiyun">
                  <div class="date"><span class="jiacu">ETA:</span>{{ dialogForm.eta }}</div>
                  <div class="address">{{ dialogForm.pod_name }}</div>
                </div>
              </div>
              <div class="xia">
                <div class="kuan">供应商编号：{{dialogForm.supplier_infoSn}}</div>
                <div class="kuan">舱位号：{{dialogForm.order_sn}}</div>
                <div class="kuan">航线：{{ dialogForm.routeCd }}</div>
                <div class="kuan">船名航次：{{dialogForm.vessel}}/{{dialogForm.voyage}}</div>
                <div class="kuan">运输条款：{{ dialogForm.transportation_terms }}</div>
                <div class="kuan">箱源：{{ dialogForm.box_source }}</div>
                <div class="kuan">
                  提单类型：{{ dialogForm.bill_of_lading_type_desc }}
                </div>
                <div class="kuan">目的港免堆/免用箱：{{ dialogForm.freetime_desc }}</div>
                <div class="kuan">截单时间：{{ dialogForm.cutoff_bill_of_lading_time }}</div>
                <div class="kuan">进港/开港时间：{{ dialogForm.cyOpen }}</div>
                <div class="kuan">截港时间：{{ dialogForm.cutoff_enter_the_port_time }}</div>
                <div class="kuan">
                  运价有效期：{{ dialogForm.freight_rate_state_time }} -
                  {{ dialogForm.freight_rate_end_time }}
                </div>
                <div class="kuan">
                  品名要求：
                  <el-popover placement="bottom" width="200" trigger="click">
                    <p v-for="(it,idx) in dialogForm.product_name" :key="idx">
                      {{ it }}
                    </p>
                    <div class="cilick" slot="reference">点击查看</div>
                  </el-popover>
                </div>
              </div>
              <!-- 箱型 -->
              <el-table :data="dialogForm.basic_freight">
                <el-table-column property="box_type" label="箱型" width="75"></el-table-column>
                <el-table-column property="price" label="价格(USD)"></el-table-column>
                <el-table-column property="dead_freight" label="亏舱费(CNY)"></el-table-column>
                <el-table-column property="overweight" label="限重">
                  <template slot-scope="scope">
                      {{scope.row.overweight==0?'不限重':'限重'}}
                  </template>
                </el-table-column>
                <el-table-column  width="380" property="weight_limit" label="限重规则">
                    <template slot-scope="scope">
                        <div v-if="scope.row.weight_limit==''">--</div>
                        <div v-else>
                          <el-table
                          border
                          style="width: 500px"
                            :data="scope.row.weight_limit">
                            <el-table-column  width="130" property="min_weight" label="最小重量（kgs）">
                                <template slot-scope="scopeItem">
                                    {{scopeItem.row.min_weight!=''?scopeItem.row.min_weight:'--'}}
                                </template>
                            </el-table-column>
                            <el-table-column  width="130" property="max_weight" label="最大重量（kgs）">
                                <template slot-scope="scopeItem">
                                    {{scopeItem.row.min_weight!=''?scopeItem.row.max_weight:'--'}}
                                </template>
                            </el-table-column>
                            <el-table-column property="overweight_fees" label="超重费用">
                                <template slot-scope="scopeItem">
                                  USD {{scopeItem.row.min_weight!=''?scopeItem.row.overweight_fees:'--'}}
                                </template>
                            </el-table-column>
                          </el-table>
                        </div>
                    </template>
                </el-table-column>
              </el-table>
            </div>
            <!-- <div slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="dialogFormVisible = true">舱位确认</el-button>
            </div> -->
          </el-dialog>
          <!-- 选择想要确定的舱位数量 -->
          <el-dialog width="35%" title="舱位确认" 
            :visible.sync="dialogFormVisible"
            top="30vh"
            @close-on-press-escape="quxiao"
            @close-on-click-modal="quxiao"
            @close="quxiao">
            <!-- {{dialogBox}} -->
            <div class="dialogBox">
              <div v-for="(item,index) in dialogBox.boxtype" :key="index">
                <div>{{item.box_type}}</div>
                <el-input-number v-model="item.number" :min="0" :max="100" label="描述文字"></el-input-number>
              </div>
            </div>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="tijiaoFaqi">发 起</el-button>
              <!-- <el-button type="primary" @click="tijiaoFaqi">确 定</el-button> -->
            </div>
          </el-dialog>

        </div>
    </div>
</template>

<script>
import Animation from './AnimationPage.vue';
import { currentCabinValidList,askAboutShippingSpace } from "@/api/api";
export default {
    components:{
        Animation,
    },
    data(){
        return{
            // 背景动画效果
            isDiMianVisible: false,
            isChuanVisible: false,
            isJiZhuangXiangVisible: false,
            isFangZiVisible: false,
            isDiaoJiVisible: false,
            lastScrollTop: 0,
            // 现舱列表数据:
            xcscList:[],
            xcscreverseList:[],
            // 标题
            xc_parentMessage:{
                title:'现舱市场',
                content:'供应商发布海量现舱资源等你来'
            },
            // 要确定的舱位箱型数量
            dialogFormVisible:false,
            dialogBox:{
              shipping_space_id:'',
              boxtype:[]
            },
            headers:{
                token: localStorage.getItem('token')
            },
            classOption: {
              direction:2,
              singleWidth: 430,   // 偏移量  单位px
              limitMoveNum:9,  // 最少几条数据可以滚动
              waitTime:2000,  // 滚动完  展示数据展示多长时间
              step:1,  // 当前滚动速度  默认1(最小速度)
            },
            dialogForm:{},
            dialogVisible:false,
        }
    },
    methods:{
      quxiao(){
        this.dialogFormVisible = false
        this.classOption.limitMoveNum = 9
      },
      faqi(e){
        if(localStorage.getItem('userInfo')){
            let is_vip=JSON.parse(localStorage.getItem('userInfo')).is_vip
            let is_authentication= JSON.parse(localStorage.getItem('userInfo')).is_authentication
            if(is_authentication!=2){
                  if(is_authentication==0){
                    this.$confirm('您还未进行身份认证，请先进行认证', '提示', {confirmButtonText: '去认证',cancelButtonText: '取消',type: 'warning'}).then(async() => {
                      this.$router.push({
                        name:'UserInfo',
                        params:{
                          menuInx: '2'
                        }
                      })
                    }).catch(() => {
                      this.$message({
                        type: 'info',
                        message: '已取消'
                      });          
                    });
                  }else{
                    this.$confirm('您的认证还未通过，请等待审核', '提示', {confirmButtonText: '去查看',cancelButtonText: '取消',type: 'warning'}).then(async() => {
                      this.$router.push({
                        name:'UserInfo',
                        params:{
                          menuInx: '2'
                        }
                      })
                    }).catch(() => {
                      this.$message({
                        type: 'info',
                        message: '已取消'
                      });          
                    });
                  }
                  
                  return
              }

            if(is_vip==0){
              this.$message({
                type:'error',
                message:'您还不是会员，请先购买会员'
              })
              return
            }
          }else{
            this.$message({
                type:'error',
                message:'您还未登录/注册，请先进行登录/注册'
              })
              return
          }

        this.dialogVisible = true
        this.dialogBox.shipping_space_id = e.shipping_space_id
        this.dialogBox.boxtype = e.basic_freight
        this.dialogForm = e
        this.dialogForm.shipping_companyLogo = e.shipping_company.logo
        this.dialogForm.supplier_infoSn = e.shipping_company.sn


        for (let i = 0; i < this.dialogBox.boxtype.length; i++) {
          this.dialogBox.boxtype[i].number=0
        }

        this.classOption.limitMoveNum = this.xcscList.length+10
      },
      async tijiaoFaqi(){
        try {
          const res = await askAboutShippingSpace(this.dialogBox,this.headers)
          
          if( res.code == 1 ) {
            this.dialogFormVisible = false
            this.$message({
              type:'success',
              message:'发起成功'
            })
            this.classOption.limitMoveNum = 9
          }else{
            this.$message({
              type:'error',
              message:res.msg
            })
          }
        } catch (error) {
          console.log(error,'失败');
        }
      },
      chakangengduo(){
        this.$router.push('/Market')
        sessionStorage.setItem('lineIndex',2)
      },
        // 背景动画效果
        handleScrollBack() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const mapContainer = this.$refs.mapContainer;
            if (mapContainer) {
                const rect = mapContainer.getBoundingClientRect();
                const isInmapContainer = rect.top < window.innerHeight && rect.bottom > 0;
                if (isInmapContainer && scrollTop > this.lastScrollTop) {
                this.showElementsSequentially();
                }
                // else{
                //   this.resetVisibilityAA()
                // }

                // 更新最后滚动位置
                this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
            }
        },
        showElementsSequentially() {
            setTimeout(() => {
                this.isDiMianVisible = true;
            }, 1000); // 地面

            setTimeout(() => {
                    this.isChuanVisible = true;
            }, 3000); // 船
        
            // setTimeout(() => {
            //   this.linesTwo.forEach(() => {
            //       this.isJiZhuangXiangVisible = true;
            //   });
            // }, 3000); // 集装箱

            setTimeout(() => {
                    this.isFangZiVisible = true;
            }, 2000); // 房子

            setTimeout(() => {
                    this.isDiaoJiVisible = true;
            }, 5000); // 吊机
        },
        // 获取列表
        async getList(){
          const res = await currentCabinValidList();
          if (res.code == 1) {
            this.xcscList = [...res.data];
            this.xcscreverseList = [...res.data].reverse();

            // 获取xc_son的宽度
            this.$nextTick(() => {
              const firstElement = document.querySelector('.xc_son');
              if (firstElement) {
                const width = firstElement.offsetWidth;
                this.classOption.singleWidth = width+12
              }
            });
          }
        },
        tiaozhuan(e){
          if(localStorage.getItem('userInfo')){
            let is_authentication= JSON.parse(localStorage.getItem('userInfo')).is_authentication
            let is_vip=JSON.parse(localStorage.getItem('userInfo')).is_vip
            if(is_authentication!=2){
                  if(is_authentication==0){
                    this.$confirm('您还未进行身份认证，请先进行认证', '提示', {confirmButtonText: '去认证',cancelButtonText: '取消',type: 'warning'}).then(async() => {
                      this.$router.push({
                        name:'UserInfo',
                        params:{
                          menuInx: '2'
                        }
                      })
                    }).catch(() => {
                      this.$message({
                        type: 'info',
                        message: '已取消'
                      });          
                    });
                  }else{
                    this.$confirm('您的认证还未通过，请等待审核', '提示', {confirmButtonText: '去查看',cancelButtonText: '取消',type: 'warning'}).then(async() => {
                      this.$router.push({
                        name:'UserInfo',
                        params:{
                          menuInx: '2'
                        }
                      })
                    }).catch(() => {
                      this.$message({
                        type: 'info',
                        message: '已取消'
                      });          
                    });
                  }
                  
                  return
              }

            if(is_vip==0){
              this.$message({
                type:'error',
                message:'您还不是会员，请先购买会员'
              })
              return
            }
          }else{
            this.$message({
                type:'error',
                message:'您还未登录/注册，请先进行登录/注册'
              })
              return
          }
          sessionStorage.setItem('parameter',JSON.stringify(e))
          this.$router.push({
            name:'MarketBookingSpace',
            params:e
          })
        }

    },
    mounted(){
        // 背景动画效果
        window.addEventListener('scroll', this.handleScrollBack);

        this.getList()
    },
    beforeDestroy() {
        // 背景动画效果
        window.removeEventListener('scroll', this.handleScrollBack);
    },
}
</script>

<style lang="scss" scoped>
.mappp{
      position: relative;
      width:100%;
      // height:100%;
      height: 950px;
      padding-bottom: 240px;
    }
  .map_xiao{
    position: absolute;
  }
  .map_xiao_111{
    right: 0;
    bottom: 18px;
    width: 1920px;
    height: 14px;
    background-image:url('../../assets/images/background/地面@2x.png');	
    background-repeat: no-repeat;
    background-size:100% 100%;
    z-index: 1;
    // opacity: 0;
    // transform: opacity 1s ease-in-out;
    animation: donghua 1s infinite;
    animation-iteration-count: 1;
  }
  
  .map_xiao_1{
    bottom: 0px; 
    right: 122px;
    width:1759px;
    height:388px;
    background-image:url('../../assets/images/background/船@2x.png');	
    background-repeat: no-repeat;
    background-size:100% 100%;
    z-index: 3;
    animation: donghua 2s infinite;
    animation-iteration-count: 1;
  }

  .map_xiao_3{
    bottom: 32px;
    right: 152px;
    width:268px;
    height:224px;
    background-image:url('../../assets/images/background/房子@2x.png');	
    background-repeat: no-repeat;
    background-size:100% 100%;
    z-index: 2;
    animation: donghua 1s infinite;
    animation-iteration-count: 1;
  }
  .map_xiao_4{
    bottom: 212px;
    right: 40px;
    width:984px;
    height:465px;
    background-image:url('../../assets/images/background/吊机@2x.png');	
    background-repeat: no-repeat;
    background-size:100% 100%;
    z-index: 4;
    animation: donghua 1s infinite;
    animation-iteration-count: 1;
  }

  .xiancsj{
    // height: 100%;
    // margin-top: 60px;
    position: relative; /* 确保内容部分在背景之上 */
  z-index: 10; /* 可选，根据布局需要调整 */
    .xcsj_bt{
      // margin-top: 68px;
      margin-bottom: 32px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 24px;
        color: #999999;
        line-height: 28px;
        font-style: normal;
        text-transform: none;
        .xc_left{
            font-size: 32px;
            color: #000000;
            line-height: 38px;
        }
    }
    .xc_right .el-button{
        width: 120px;
        height: 48px;
        background: #064FAF;
        border-radius: 26px 26px 26px 26px;
        img{
          width: 16px;
          height: 16px;
        }
    }
    .xc_concent{
        display: flex;
        align-items: center;
        overflow: hidden;
        // justify-content:space-between;
    }
    .xc_concenter{
      flex-wrap: wrap;
    }
    .xc_son{
        margin-right: 12PX;
        margin-bottom: 12PX;
        width: 418px;
        // height: 345px;
        background: #fff;
        border-radius: 12px 12px 12px 12px;
        // border: 1px solid #E4E6E8;
        cursor: pointer;
        // padding: 15px;
        background-image:url('@/assets/images/hpcopy/mtxBj.png');	
        background-repeat: no-repeat;
        background-size:100% 132px;
        .son_title{
            display: flex;
            align-items: center;
            justify-content: flex-start;
            font-weight: 500;
            font-size: 20px;
            color: #1D3A66;
            padding: 20px 20px 0;
            span{
                display: inline-block;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
            img{
              width: 26x;
              height: 4px;
              margin: 0 8px;
            }
        }
        .son_num{
            padding: 0px 20px 0;
            margin: 8px 0 15px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            // width: 155px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-weight: 500;
            font-size: 16px;
            color: #064FAF;
            text-align: left;
            font-style: normal;
            text-transform: none;
        }

        .son_con{
            width: 100%;
            height: 252px;
            background: #FFFFFF;
            border-radius: 12px 12px 0px 0px;
            border: 1px solid #DCDFE4;
            border-bottom: 0;
            .son_f{
                padding-top: 20px;
            }
            .spanspan{
                    color: #999999;
                    text-align: justified;
                    margin-left: 12px;
                    width: 89px;
                    text-align: right;
                    display: inline-block;

                    font-weight: 400;
                    font-size: 16px;
                    color: #999999;
                }
            div{
              height: 22px;
              padding-top: 16px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 16px;
                color: #333333;
                text-align: left;
                font-style: normal;
                text-transform: none;
                span{
                    color: #999999;
                    text-align: justified;
                    margin-left: 12px;
                }
            }

        }
    }
}

// 版心
.typeArea{
    width: 1774px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    // background: palegoldenrod;
}



.querem{
  width: 100%;
  height: 44px;
  text-align: center;
  border-radius:  0px 0px 12px 12px;
  border: 1px solid #DCDFE4;
  border-top: 0;
  padding-bottom: 12px;
  cursor: default;
  .el-button{
    width: 126px;
    height: 44px;
    background: rgba(42, 134, 255, 0.12);
    border: 0;
    color: #064FAF;
    font-size: 16px;
  }

  .el-button:hover{
    background: #064FAF;
    color: #FFFFFF;
  }
}

.dialogBox{
  display: flex;
  justify-content: space-around;
}

.warp {
  // height: 658PX;
  // width: 22.5rem;
  // margin: 0 auto;
  overflow: hidden;
  box-sizing: border-box;
}

.dialogForm{
  .shang {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 84px;
    border-bottom: #eee solid 1px;
    .logo {
      width: 48px;
      // height: 48px;
      margin-right: 40px;
      img{
        width: 65px;

      }
    }
    .qiyun {
      // width: 120px;
      .date {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #333333;
        line-height: 19px;
        text-align: center;
        font-style: normal;
        text-transform: none;

        margin-bottom: 4px;
      }
      .address {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 20px;
        color: #333333;
        line-height: 28px;
        font-style: normal;
        text-transform: none;

        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .dao {
      width: 100px;
      text-align: center;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 12px;
      color: #999999;
      font-style: normal;
      text-transform: none;

      margin: 0 24px;
      img {
        width: 100px;
        height: 7px;
      }
      div {
        height: 12px;
      }
    }
  }

  .xia{
    margin-top: 24px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .kuan{
      margin-right: 24px;
      margin-bottom: 8px;
      display: flex;
    }

    .cilick{
      cursor: pointer;
      color: #0073f5;
    }
  }
}
</style>